export default __webpack_public_path__ + "static/media/bianji_w.010e5a7b.png";